
export default {
  vessel: {
    textColumn: {
      textAlign: 'center',
      lg: {
        textAlign: 'left'
      }
    },
    title: {
      fontSize: '2xl',
      marginBottom: 'sm'
    }
  },
  data() {
    return {
      stack: null
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.stack = await $content(locale, 'shop/stack').fetch()
  }
}
